export default "__VITE_ASSET__JoDVFM9v__"